// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-7ff6fac9] {\n  margin: 3rem 0 2rem;\n  line-height: 110%;\n}\nh2[data-v-7ff6fac9] {\n  margin: 2rem 0 1rem;\n  line-height: 110%;\n}\nh3[data-v-7ff6fac9] {\n  margin: 1rem 0 0.5rem;\n  line-height: 110%;\n}", ""]);
// Exports
module.exports = exports;
